module.exports = __webpack_public_path__ + "static/media/logo.ee0e49cb.png";